import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useRef, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faPlusSquare, faCode } from '@fortawesome/free-solid-svg-icons'

export default function OptionsInput(props) {
  const { entity, options = [], id = 'OptioningOptionsInput', name = 'options', onChange } = props

  const inputRow = useRef(null)
  const groupRef = useRef(null)

  const handleChange = (e, index, key) => {
    const updated = [...options]
    const value = e.target.value
    if (!value) {
      delete updated[index][key]
    } else {
      updated[index][key] = value
    }
    if (onChange) {
      onChange(name, updated)
    }
  }

  const removeOption = index => {
    const updated = [...options]
    updated.splice(index, 1)
    if (onChange) {
      onChange(name, updated)
    }
  }

  const addOption = (item = 0) => {
    const updated = [...options]
    const newItem = {
      code: inputRow.current.querySelectorAll(`input`).item(0).value,
      name: inputRow.current.querySelectorAll(`input`).item(1).value
    }
    const net = inputRow.current.querySelectorAll(`input`).item(2).value
    if (net) newItem.net = net
    updated.push(newItem)
    if (onChange) {
      onChange(name, updated)
    }

    setTimeout(() => {
      const index = groupRef.current.querySelectorAll(`input`).length + item - 6
      groupRef.current.querySelectorAll(`input`).item(index).focus()
    })
  }

  return (
    <Fragment>
      <Form.Label className="mt-2 mb-0 d-block">Options</Form.Label>
      <Form.Text className="text-muted">Add purchase options for the offering here.</Form.Text>
      <Form.Group
        ref={groupRef}
        controlId={`${id}`}>
        {(options || []).map((option, index) => (
          <Row
            key={index}
            className="mb-2">
            <Col xs={3}>
              <Form.Control
                onChange={e => handleChange(e, index, 'code')}
                placeholder="Option code"
                value={option.code}
                type="text"
                required
              />
              <Form.Control.Feedback type="invalid">Please enter a code</Form.Control.Feedback>
            </Col>
            <Col xs={4}>
              <Form.Control
                onChange={e => handleChange(e, index, 'name')}
                placeholder="Option name"
                value={option.name}
                type="text"
                required
              />
              <Form.Control.Feedback type="invalid">Please enter a name</Form.Control.Feedback>
            </Col>
            <Col xs={3}>
              <Form.Control
                onChange={e => handleChange(e, index, 'net')}
                placeholder="Net price (if different)"
                value={option.net}
                type="number"
              />
              <Form.Control.Feedback type="invalid">Please enter a number</Form.Control.Feedback>
            </Col>
            <Col
              xs={2}
              className="text-end">
              <FontAwesomeIcon
                icon={faTimesCircle}
                title="Delete option"
                className="cursor-pointer mt-2 text-secondary"
                onClick={e => removeOption(index)}
              />
            </Col>
          </Row>
        ))}
        <Row
          key={options.length}
          className="mb-2"
          ref={inputRow}>
          <Col xs={3}>
            <Form.Control
              onChange={e => addOption(0)}
              placeholder="Option code"
              type="text"
            />
            <Form.Control.Feedback type="invalid">Please enter a code</Form.Control.Feedback>
          </Col>
          <Col xs={4}>
            <Form.Control
              onChange={e => addOption(1)}
              placeholder="Option name"
              type="text"
            />
            <Form.Control.Feedback type="invalid">Please enter a name</Form.Control.Feedback>
          </Col>
          <Col xs={3}>
            <Form.Control
              onChange={e => addOption()}
              placeholder="Net price (if different)"
              type="number"
            />
            <Form.Control.Feedback type="invalid">Please enter a number</Form.Control.Feedback>
          </Col>
          <Col
            xs={2}
            className="text-end">
            <FontAwesomeIcon
              icon={faPlusSquare}
              className="cursor-pointer mt-2 text-secondary"
              onClick={e => addOption()}
            />
          </Col>
        </Row>
      </Form.Group>
    </Fragment>
  )
}
